import {
  Component,
  InjectionToken,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormGroupDirective, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { FormBuilderService } from '../../services/form-builder.service';
import { InputBaseType } from '../../types';
import {
  FieldsetBaseType,
  FormBuilderFieldsetComponentType,
} from '../../types/form-fieldset.type';
import {
  FormBuilderInputComponent,
  FORM_BUILDER_INPUT_TOKEN,
} from '../form-builder-input';

export const FORM_BUILDER_FIELDSET_TOKEN =
  new InjectionToken<FormBuilderFieldsetComponentType>('FormBuilder_Fieldset');

@Component({
  selector: 'rd-form-builder-fieldset',
  templateUrl: './form-builder-fieldset.component.html',
  providers: [
    {
      provide: FORM_BUILDER_FIELDSET_TOKEN,
      useExisting: FormBuilderFieldsetComponent,
    },
  ],
  standalone: false,
})
export class FormBuilderFieldsetComponent
  implements FormBuilderFieldsetComponentType, OnInit, OnDestroy
{
  @Input() props: FieldsetBaseType;
  @Input() formGroupName: string;

  @ViewChildren(FORM_BUILDER_INPUT_TOKEN)
  formInputs: QueryList<FormBuilderInputComponent>;

  fieldsetProps: FieldsetBaseType;
  fieldsetElements: InputBaseType[];
  destroy$ = new Subject();

  // Bridge pattern attributes
  formGroup: UntypedFormGroup;
  isSubmitted$: Subject<boolean> = new Subject();

  constructor(
    public formGroupDirective: FormGroupDirective,
    private formBuilderService: FormBuilderService,
  ) {}

  ngOnInit(): void {
    this.formGroup = this.formGroupDirective.control.get(
      this.formGroupName,
    ) as UntypedFormGroup;
    this.fieldsetProps = this.formBuilderService.buildFieldsetProps(this.props);
    this.fieldsetElements = this.fieldsetProps.elements.map((el) => el.input);

    this.isSubmitted$.pipe(takeUntil(this.destroy$), take(1)).subscribe(() => {
      this.formInputs.forEach((input) => input.isSubmitted$.next(true));
      this.formGroup.markAllAsTouched();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
